<template>
  <b-card>
    <b-row>
      <!-- Main table element -->
      <b-table
        :items="items"
        :fields="fields"
        :busy="isLoading"
        striped
        hover
        responsive
      >
        <template v-slot:cell(startAt)="data">
          {{ data.value|moment("DD/MM/YYYY")}}
        </template>

        <template v-slot:cell(sendAt)="data">
          {{ data.value|moment("DD/MM/YYYY")}}
        </template>

        <template v-slot:cell(publishedAt)="data">
          {{ data.value|moment("DD/MM/YYYY")}}
        </template>

        <template v-slot:cell(cancelledAt)="data">
          {{ data.value|moment("DD/MM/YYYY")}}
        </template>

        <template v-slot:cell(endAt)="data">
          {{ data.value|moment("DD/MM/YYYY")}}
        </template>

        <template v-slot:cell(eventDate)="data">
          {{ data.value|moment("DD/MM/YYYY")}}
        </template>

        <template v-slot:cell(status)="data">
          <app-btn :text="data.value"></app-btn>
        </template>

        <template v-slot:cell(type)="data">
          <app-btn :text="data.value"></app-btn>
        </template>

        <template v-slot:cell(person)="data">
          <a :href="'/#/people/' + data.value.id">
            {{ data.value.name }} {{ data.value.surname }}
          </a>
        </template>

        <template v-slot:cell(actions)="data">
          <b-button
            :href="'/#/' + itemUrl.replace('{id}', data.item.id)"
            variant="info"
          >
            View
          </b-button>
        </template>

        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
    </b-row>
    <!--- Pagination  ---->
    <b-row>
      <b-col sm="5" md="6">
        <b-pagination
          :total-rows="pagination.totalItems"
          :per-page="pagination.limit"
          :value="pagination.page"
          @change="onPageChange"
          align="fill"
          size="sm"
        ></b-pagination>
      </b-col>
      <b-col sm="5" md="6">
        <b-form-group
          label="Per page"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          label-for="perPageSelect"
          class="mb-0"
        >
          <b-form-select
            @change="onLimitChange"
            size="sm"
            :value="pagination.limit"
            :options="[10, 25, 50, 100]"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
    import {PaginationMeta} from "../../models/PaginationMeta";
    import AppBtn from "./AppBtn";

    export default {
        name: 'pagination-table',
        components: {
            AppBtn,
        },
        props: {
            items: {
                type: Array,
                default: new Array(),
            },
            fields: {
                type: Array,
                default: new Array(),
            },
            pagination: {
                type: Object,
                default: new PaginationMeta(),
            },
            itemUrl: {
                type: String,
                default: '',
            },
            isLoading: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            onPaginationChange() {
                this.isLoading = true
                this.$emit('change')
            },
            onPageChange(val) {
                this.pagination.page = val
                this.onPaginationChange()
            },
            onLimitChange(val) {
                this.pagination.limit = val
                this.onPaginationChange()
            },
        },
    }
</script>
